import React, { useEffect } from "react";
import { Layout } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/app";
import LogInRegisterHeader from "../../webPages/CommonComponent/LogInRegisterHeader";
import Footer from "../../webPages/CommonComponent/Footer";
import { setTranlsation } from "../../../store/CommonSlice";

/**
 * Renders the wrapper layout component for login, register ,
 * reset password and forgot password.
 *
 * @return {ReactElement} The rendered authentication layout component.
 */
const AuthLayout: React.FC = () => {
  const navigate = useNavigate();
  const Auth = useSelector((state: RootState) => state.AUTH);
  const webTrackingUrl = useLocation()
  const dispatch: AppDispatch = useDispatch();

  // If user is already logged in, redirect to dashboard
  useEffect(() => {
    if (Auth.token) {
      navigate("/dashboard");
    }
  }, [Auth.token, navigate]);



  useEffect(() => {
    dispatch(setTranlsation({ show: true, className: 'unauth-translate' }));
    return (() => {
      dispatch(setTranlsation({ show: false, className: '' }));
    })
  }, []);

  return (
    <Layout className={`main__page__wrapper has__header`}>
      <Layout.Content className="main__page__content">
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}

export default AuthLayout;
